.admin {
  min-height: 100vh;
  background: var(--bg-primary);
  color: var(--text-primary);
  font-family: 'Space Grotesk', sans-serif;
  
  background-image: 
      linear-gradient(rgba(0, 240, 255, 0.03) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0, 240, 255, 0.03) 1px, transparent 1px);
  background-size: 32px 32px;
  background-position: center;
}

.container {
  max-width: 1600px;
  margin: 0 auto;
  padding: var(--space-xl);
  display: flex;
  flex-direction: column;
  gap: var(--space-lg);
}

/* Header */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(0, 240, 255, 0.3);
  padding-bottom: var(--space-md);
}

.headerLeft {
  display: flex;
  align-items: baseline;
  gap: var(--space-lg);
}

.title {
  font-family: var(--font-heading);
  font-size: var(--text-2xl);
  color: var(--accent-cyan);
  text-shadow: 0 0 15px var(--glow-cyan);
  letter-spacing: 6px;
  margin: 0;
  text-transform: uppercase;
}

.count {
  font-family: var(--font-code);
  font-size: var(--text-sm);
  color: var(--text-secondary);
}

.headerRight {
  display: flex;
  gap: var(--space-md);
}

/* Brutal Panel Wrapper */
.brutalPanel {
  background-color: rgba(10, 10, 15, 0.8);
  border: 1px solid var(--border);
  padding: var(--space-lg);
  position: relative;
  backdrop-filter: blur(8px);
}

.brutalPanel::before, .brutalPanel::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 12px;
  border: 2px solid var(--accent-cyan);
  opacity: 0.6;
  pointer-events: none;
}
.brutalPanel::before { top: -1px; left: -1px; border-right: none; border-bottom: none; }
.brutalPanel::after { bottom: -1px; right: -1px; border-left: none; border-top: none; }


/* Toolbar */
.toolbar {
  display: flex;
  gap: var(--space-md);
  align-items: center;
  flex-wrap: wrap;
}

.searchWrap {
  flex: 1;
  min-width: 300px;
  display: flex;
  align-items: center;
  background: rgba(0, 240, 255, 0.03);
  border: 1px solid rgba(0, 240, 255, 0.2);
  border-bottom: 2px solid var(--accent-cyan);
  padding: 0 var(--space-md);
  transition: all 0.2s;
}

.searchWrap:focus-within {
  background: rgba(0, 240, 255, 0.08);
  box-shadow: 0 4px 15px rgba(0, 240, 255, 0.1);
}

.searchPrompt {
  color: var(--accent-green);
  font-family: var(--font-code);
  margin-right: var(--space-sm);
  font-weight: bold;
}

.search {
  flex: 1;
  background: transparent;
  border: none;
  padding: 12px 0;
  color: var(--text-primary);
  font-family: var(--font-code);
  font-size: var(--text-sm);
  outline: none;
}
.search::placeholder {
  color: rgba(255,255,255,0.2);
}

.select {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--border);
  border-radius: 0;
  padding: 10px 32px 10px var(--space-md);
  color: var(--accent-cyan);
  font-family: var(--font-code);
  font-size: var(--text-sm);
  outline: none;
  cursor: pointer;
  text-transform: uppercase;
  appearance: none;
  background-image: url('data:image/svg+xml;utf8,<svg fill="%2300f0ff" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>');
  background-repeat: no-repeat;
  background-position: right 4px center;
}
.select option {
  background: var(--bg-primary);
  color: var(--text-primary);
}

/* Buttons */
.btn, .btnPrimary, .btnDanger {
  font-family: var(--font-code);
  font-size: var(--text-sm);
  padding: 10px var(--space-lg);
  text-transform: uppercase;
  font-weight: 700;
  border: 1px solid;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  letter-spacing: 1px;
}

.btn {
  background: rgba(255, 255, 255, 0.05);
  color: var(--text-primary);
  border-color: var(--border);
}
.btn:hover {
  border-color: var(--accent-cyan);
  color: var(--accent-cyan);
}

.btnPrimary {
  background: rgba(0, 240, 255, 0.1);
  color: var(--accent-cyan);
  border-color: var(--accent-cyan);
}
.btnPrimary:hover {
  background: var(--accent-cyan);
  color: var(--bg-primary);
  box-shadow: 0 0 15px var(--glow-cyan);
}

.btnDanger {
  background: rgba(255, 0, 100, 0.1);
  color: var(--accent-magenta);
  border-color: var(--accent-magenta);
}
.btnDanger:hover:not(:disabled) {
  background: var(--accent-magenta);
  color: var(--bg-primary);
  box-shadow: 0 0 15px rgba(255, 0, 100, 0.5);
}
.btnDanger:disabled {
  opacity: 0.3;
  cursor: not-allowed;
  border-color: var(--border);
  color: var(--text-secondary);
}

/* Table */
.tableWrap {
  overflow-x: auto;
}

.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 8px;
  font-family: var(--font-code);
  font-size: var(--text-sm);
}

.table thead {
  background: transparent;
}

.table th {
  padding: var(--space-sm) var(--space-md);
  text-align: left;
  color: var(--accent-cyan);
  font-weight: 700;
  font-size: var(--text-xs);
  text-transform: uppercase;
  letter-spacing: 2px;
  border-bottom: 1px dashed rgba(0, 240, 255, 0.3);
  white-space: nowrap;
}

.thCheck { width: 50px; text-align: center; }

.thSortable { cursor: pointer; user-select: none; }
.thSortable:hover { color: #fff; text-shadow: 0 0 5px var(--glow-cyan); }

.table tbody tr {
  background: rgba(255, 255, 255, 0.02);
  transition: all 0.2s;
}

.table td {
  padding: 14px var(--space-md);
  vertical-align: middle;
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
}
.table tbody tr td:first-child { border-left: 1px solid transparent; }
.table tbody tr td:last-child { border-right: 1px solid transparent; }

.table tbody tr:hover {
  background: rgba(0, 240, 255, 0.05);
}
.table tbody tr:hover td {
  border-top: 1px solid rgba(0, 240, 255, 0.2);
  border-bottom: 1px solid rgba(0, 240, 255, 0.2);
}
.table tbody tr:hover td:first-child { border-left: 1px solid rgba(0, 240, 255, 0.2); }
.table tbody tr:hover td:last-child { border-right: 1px solid rgba(0, 240, 255, 0.2); }

.rowSelected {
  background: rgba(0, 240, 255, 0.08) !important;
}
.rowSelected td {
  border-top: 1px solid var(--accent-cyan) !important;
  border-bottom: 1px solid var(--accent-cyan) !important;
}
.rowSelected td:first-child { border-left: 1px solid var(--accent-cyan) !important; }
.rowSelected td:last-child { border-right: 1px solid var(--accent-cyan) !important; }


.tdCheck { text-align: center; }

/* Custom Checkbox */
.checkboxWrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
}
.checkboxWrap input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkmark {
  display: inline-block;
  width: 18px;
  height: 18px;
  background-color: rgba(0,0,0,0.5);
  border: 1px solid var(--border);
  transition: all 0.2s;
  position: relative;
}
.checkboxWrap:hover input ~ .checkmark { border-color: var(--accent-cyan); }
.checkboxWrap input:checked ~ .checkmark {
  background-color: rgba(0, 240, 255, 0.15);
  border-color: var(--accent-cyan);
  box-shadow: 0 0 10px rgba(0, 240, 255, 0.4);
}
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.checkboxWrap input:checked ~ .checkmark:after { display: block; }
.checkboxWrap .checkmark:after {
  left: 5px;
  top: 1px;
  width: 4px;
  height: 10px;
  border: solid var(--accent-cyan);
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.tdTitle {
  max-width: 360px;
}

.docTitle {
  display: block;
  color: var(--text-primary);
  font-weight: 700;
  font-size: 15px;
  font-family: var(--font-heading);
  letter-spacing: 1px;
}

.docSlug {
  display: block;
  margin-top: 4px;
  color: rgba(0, 240, 255, 0.5);
  font-size: 11px;
}

.catBadge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  background: rgba(255, 255, 255, 0.05);
  border-left: 2px solid rgba(255,255,255,0.3);
  font-size: 11px;
  white-space: nowrap;
  letter-spacing: 1px;
}

.tdDate {
  white-space: nowrap;
  color: var(--text-secondary);
  font-size: 12px;
}

.statusBadge {
  display: inline-block;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
}

.statusPublished {
  color: var(--accent-green);
  background: rgba(57, 255, 20, 0.1);
  border: 1px solid rgba(57, 255, 20, 0.3);
  box-shadow: 0 0 10px rgba(57, 255, 20, 0.1);
}

.statusDraft {
  color: #ffaa00;
  background: rgba(255, 170, 0, 0.1);
  border: 1px solid rgba(255, 170, 0, 0.3);
}

.statusArchived {
  color: var(--text-secondary);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--border);
}

.tdTags {
  max-width: 240px;
}

.tagsWrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.tag {
  display: inline-block;
  padding: 2px 8px;
  background: rgba(147, 112, 219, 0.1);
  border: 1px solid rgba(147, 112, 219, 0.3);
  color: #b794f6;
  font-size: 10px;
  white-space: nowrap;
}

.tagMore {
  font-size: 10px;
  color: var(--text-secondary);
  padding: 3px 0;
}

.btnSmall {
  font-family: var(--font-code);
  font-size: 10px;
  padding: 4px 10px;
  text-transform: uppercase;
  font-weight: 700;
  border: 1px solid var(--border);
  background: rgba(255,255,255,0.05);
  color: var(--text-primary);
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  letter-spacing: 1px;
}

.btnSmall:hover {
  border-color: var(--accent-cyan);
  color: var(--accent-cyan);
  background: rgba(0, 240, 255, 0.1);
}

.btnPublish {
  background: rgba(57, 255, 20, 0.1);
  border-color: rgba(57, 255, 20, 0.4);
  color: #39ff14;
  margin-left: 6px;
}
.btnPublish:hover {
  background: rgba(57, 255, 20, 0.3);
  color: #fff;
  border-color: #39ff14;
}

/* Modal specific styles */
.modalOverlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  backdrop-filter: blur(8px);
}

.modal {
  background: rgba(10, 10, 15, 0.95);
  border: 1px solid var(--accent-cyan);
  box-shadow: 0 0 30px rgba(0, 240, 255, 0.2);
  padding: var(--space-xl);
  width: 94vw;
  max-width: 1400px;
  max-height: 92vh;
  overflow-y: auto;
  position: relative;
}

.modal::before, .modal::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid var(--accent-cyan);
  pointer-events: none;
}
.modal::before { top: 0; left: 0; border-right: none; border-bottom: none; }
.modal::after { bottom: 0; right: 0; border-left: none; border-top: none; }


.modalTitle {
  font-family: var(--font-heading);
  font-size: var(--text-xl);
  color: var(--accent-cyan);
  margin-bottom: var(--space-md);
  letter-spacing: 2px;
  text-transform: uppercase;
}

.modalBody {
  display: grid;
  grid-template-columns: 350px 1fr;
  gap: var(--space-xl);
  min-height: 500px;
}

.modalLeft, .modalRight {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}

.formGroup { margin-bottom: 0; }
.formGroup label {
  display: block;
  font-family: var(--font-code);
  font-size: 11px;
  color: var(--text-secondary);
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.input {
  width: 100%;
  background: rgba(255,255,255,0.03);
  border: 1px solid var(--border);
  padding: 10px var(--space-md);
  color: var(--text-primary);
  font-family: var(--font-code);
  font-size: var(--text-sm);
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
}
.input:focus {
  border-color: var(--accent-cyan);
  background: rgba(0, 240, 255, 0.05);
}

.modalActions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-md);
  margin-top: var(--space-xl);
  grid-column: 1 / -1;
  padding-top: var(--space-lg);
  border-top: 1px solid rgba(0, 240, 255, 0.2);
}

/* Doc Preview Modal（回收站/操作日志预览） */
.previewModal {
  max-width: 960px;
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}

.previewMeta {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-md);
  font-family: var(--font-code);
  font-size: 12px;
  color: var(--text-secondary);
  border: 1px solid var(--border);
  background: rgba(0, 240, 255, 0.03);
  padding: 8px var(--space-md);
}

.previewScroll {
  flex: 1;
  overflow-y: auto;
  max-height: 62vh;
  border: 1px solid var(--border);
  background: rgba(0, 0, 0, 0.35);
  padding: var(--space-lg);
}

.previewWarn {
  margin-right: auto;
  font-family: var(--font-code);
  font-size: 12px;
  color: var(--accent-magenta);
}

/* Attachments */
.attachList {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 200px;
  overflow-y: auto;
  margin-bottom: 10px;
}

.attachItem {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  padding: 8px 12px;
  background: rgba(0, 240, 255, 0.05);
  border: 1px solid rgba(0, 240, 255, 0.2);
  font-family: var(--font-code);
  font-size: 11px;
}

.attachItemName {
  flex: 1;
  color: var(--accent-cyan);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attachItemDesc {
  color: var(--text-secondary);
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attachRemove {
  background: none;
  border: none;
  color: var(--accent-magenta);
  cursor: pointer;
  font-size: 14px;
}

.attachAddRow { display: flex; gap: 8px; }
.attachAddRow .input { flex: 1; }

.attachHint {
  font-family: var(--font-code);
  font-size: 11px;
  color: var(--text-secondary);
  margin-bottom: 8px;
}
.attachHint code { color: var(--accent-cyan); }

.uploadBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: var(--font-code);
  font-size: 12px;
  padding: 10px;
  border: 1px dashed rgba(0, 240, 255, 0.5);
  color: var(--accent-cyan);
  cursor: pointer;
  transition: all 0.2s;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.uploadBtn:hover {
  background: rgba(0, 240, 255, 0.1);
  border-style: solid;
}

/* Textarea */
.textarea {
  width: 100%;
  background: rgba(255,255,255,0.03);
  border: 1px solid var(--border);
  padding: 12px;
  color: var(--text-primary);
  font-family: var(--font-code);
  font-size: var(--text-sm);
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
  resize: vertical;
}
.textarea:focus {
  border-color: var(--accent-cyan);
  background: rgba(0, 240, 255, 0.02);
}

/* Toast */
.toast {
  position: fixed;
  top: var(--space-xl);
  right: var(--space-xl);
  padding: 12px 24px;
  font-family: var(--font-code);
  font-size: var(--text-sm);
  font-weight: 700;
  letter-spacing: 1px;
  z-index: 200;
  animation: slideIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  text-transform: uppercase;
}

.toastSuccess {
  background: rgba(57, 255, 20, 0.15);
  border: 1px solid #39ff14;
  color: #39ff14;
  box-shadow: 0 0 20px rgba(57, 255, 20, 0.2);
}

.toastError {
  background: rgba(255, 0, 100, 0.15);
  border: 1px solid #ff0064;
  color: #ff0064;
  box-shadow: 0 0 20px rgba(255, 0, 100, 0.2);
}

@keyframes slideIn {
  from { transform: translateX(100%); opacity: 0; }
  to { transform: translateX(0); opacity: 1; }
}

@media (max-width: 900px) {
  .modalBody { grid-template-columns: 1fr; }
  .modal { width: 96vw; max-height: 96vh; }
}

@media (max-width: 768px) {
  .admin { padding: var(--space-md); }
  .toolbar { flex-direction: column; }
  .searchWrap { min-width: 100%; }
  .tdTitle { max-width: 200px; }
  .tdTags { max-width: 150px; }
}

/* View tabs (docs / recycle / logs) */
.viewTabs {
  display: flex;
  gap: var(--space-sm);
  flex-wrap: wrap;
}
.viewTab {
  font-family: var(--font-code);
  font-size: var(--text-sm);
  padding: 10px var(--space-md);
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: 1px;
  border: 1px solid var(--border);
  background: rgba(255, 255, 255, 0.03);
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}
.viewTab:hover { color: var(--accent-cyan); border-color: var(--accent-cyan); }
.viewTabActive {
  color: var(--accent-cyan);
  border-color: var(--accent-cyan);
  background: rgba(0, 240, 255, 0.1);
  box-shadow: 0 0 10px rgba(0, 240, 255, 0.2);
}

/* Recycle purge button (single) */
.btnPurge {
  background: rgba(255, 0, 100, 0.1);
  border-color: rgba(255, 0, 100, 0.4);
  color: var(--accent-magenta);
  margin-left: 6px;
}
.btnPurge:hover {
  background: rgba(255, 0, 100, 0.3);
  color: #fff;
  border-color: #ff0064;
}

/* Confirm modal (replaces window.confirm) */
.confirmModal {
  width: 480px;
  max-width: 92vw;
  padding: var(--space-xl);
}
.confirmMessage {
  font-family: var(--font-code);
  font-size: var(--text-sm);
  color: var(--text-primary);
  line-height: 1.6;
  margin: 0 0 var(--space-lg);
  white-space: pre-line;
  word-break: break-all;
}
.confirmActions {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-md);
}

/* Log view */
.logDesc {
  max-width: 320px;
  color: var(--text-secondary);
  font-size: 12px;
  word-break: break-word;
}
.loadingRow {
  text-align: center;
  color: var(--text-secondary);
  padding: 40px !important;
}

/* Pagination */
.pagination {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  margin-top: var(--space-lg);
  flex-wrap: wrap;
}
.pageInfo {
  font-family: var(--font-code);
  font-size: 12px;
  color: var(--text-secondary);
}
